import { Skeleton } from '@mui/material'
import { Card, ValueSunburstWithTable, ValueSunburstWithTableLoading } from 'components/core-v2'

import { useFilteredGetByTenantAccountDashboardQuery } from '../../utils/useFilteredNotes'

export const CurrencySunburstChart = () => {
  const { data, isFetching, isLoading } = useFilteredGetByTenantAccountDashboardQuery()

  if (isLoading || isFetching) {
    return (
      <Card.Wrapper>
        <Card.Header>
          <Skeleton height="15px" variant="rectangular" width="160px" />
        </Card.Header>
        <ValueSunburstWithTableLoading />
      </Card.Wrapper>
    )
  }

  const { currencies } = data
  const title = `${currencies.length} ${currencies.length === 1 ? 'Currency' : 'Currencies'}`

  const chartData = currencies.map(currency => ({
    parent: '0',
    id: currency.notionalCurrency,
    name: currency.notionalCurrency,
    value: currency.zarValue,
    count: currency.numberOfActiveAccounts
  }))

  return (
    <Card.Wrapper>
      <Card.Header title={title} />
      <ValueSunburstWithTable data={chartData} seriesName="Currencies" />
    </Card.Wrapper>
  )
}
